export const MSAAS_LISTING_SEARCH_ROUTES = {
  get: '/b2b/job-listings/marketplace-search',
};

export const JOB_RESPONSE_ROUTES = {
  post: '/job-responses',
};

export const JOB_RESPONSE_BEGIN_NEGOTIATION_ROUTES = {
  post: '/job-responses/begin-negotiation',
};

export const JOB_RESPONSE_INITIAL_MESSAGE_ROUTES = {
  post: '/job-responses/initial-message',
};

export const MSAAS_LISTING_FIT_CHECK_ROUTES = {
  post: '/b2b/job-listings/{offeringId}/fit-checks',
};
